import React from 'react';
export const EyeClosedSvg: React.FC = () => {
  return (
    <svg
      width="22"
      height="18"
      viewBox="0 0 22 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11 3.5C6.27273 3.5 2.23364 6.36667 0 10.5C2.23364 14.6333 6.27273 17.5 11 17.5C15.7273 17.5 19.7664 14.6333 22 10.5C19.7664 6.36667 15.7273 3.5 11 3.5ZM11 15.1667C8.42273 15.1667 6.33364 13.0778 6.33364 10.5C6.33364 7.92222 8.42273 5.83333 11 5.83333C13.5773 5.83333 15.6664 7.92222 15.6664 10.5C15.6664 13.0778 13.5773 15.1667 11 15.1667ZM11 7.58333C9.38818 7.58333 8.08364 8.88889 8.08364 10.5C8.08364 12.1111 9.38818 13.4167 11 13.4167C12.6118 13.4167 13.9164 12.1111 13.9164 10.5C13.9164 8.88889 12.6118 7.58333 11 7.58333Z"
        fill="#888888"
      />
      <line
        x1="2.06066"
        y1="1.93934"
        x2="20.0607"
        y2="16.9393"
        stroke="#888888"
        strokeWidth="2"
      />
    </svg>
  );
};
